import React, { useRef, useEffect, useState } from "react";
import WaveSurfer from "wavesurfer.js";
import { format } from "date-fns";
// Styles
import Styles from "./Styles/MP3Player.module.css";
// Images
import forwardImage from "../../../Assets/Icons/forward.png";
import playImage from "../../../Assets/Icons/play.png";
import pauseImage from "../../../Assets/Icons/pause.png";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";

const MP3Player = ({ audioFile }) => {
  const wavesurferRef = useRef(null);
  const [playerState, setPlayerState] = useState(false); // paused
  const [currentTime, setCurrentTime] = useState("۰۰:۰۰");
  const [remainingTime, setRemainingTime] = useState("۰۰:۰۰");

  useEffect(() => {
    // Initialize WaveSurfer on component mount
    wavesurferRef.current = WaveSurfer.create({
      container: "#waveform",
      waveColor: "#4b495b",
      progressColor: "#43b0d6",
      cursorColor: "#7c7c7c",
      barWidth: 4,
      barRadius: 100,
      barHeight: 0.7,
      barGap: -1,
      cursorWidth: 4,
      responsive: true,
      height: 80,
    });

    wavesurferRef.current.load(audioFile);

    const updateRemainingTime = (currentTime) => {
      const duration = wavesurferRef.current.getDuration();
      const remainingTimeInSeconds = duration - currentTime;
      const remainingTimeInminutes = Math.floor(remainingTimeInSeconds / 60);
      const seconds = Math.floor(
        remainingTimeInSeconds - remainingTimeInminutes * 60
      );
      const ElapsedTime = Math.floor(
        currentTime - Math.floor(currentTime / 60) * 60
      );
      setCurrentTime(
        `${
          ElapsedTime.toString().length > 1 ? ElapsedTime : `۰${ElapsedTime}`
        } : ${
          Math.floor(currentTime / 60).toString().length > 1
            ? Math.floor(currentTime / 60)
            : `۰${Math.floor(currentTime / 60)}`
        }`
      );
      setRemainingTime(
        `${seconds.toString().length > 1 ? seconds : `۰${seconds}`} : ${
          remainingTimeInminutes.toString().length > 1
            ? remainingTimeInminutes
            : `۰${remainingTimeInminutes}`
        }`
      );
    };

    wavesurferRef.current.on("timeupdate", updateRemainingTime);
    wavesurferRef.current.on("finish", () => {
      return setPlayerState(false);
    });

    return () => {
      wavesurferRef.current.un("timeupdate", updateRemainingTime);
      wavesurferRef.current.destroy();
    };
  }, [audioFile]);

  const handlePlay = () => {
    if (!playerState) {
      wavesurferRef.current.play();
    } else {
      wavesurferRef.current.pause();
    }
    setPlayerState((prev) => !prev);
  };

  const goToFiveSeconds = () => {
    const currentTime = wavesurferRef.current.getCurrentTime();
    const newTime = currentTime + 5;

    wavesurferRef.current.seekTo(newTime / wavesurferRef.current.getDuration());
  };
  const backFiveSeconds = () => {
    const currentTime = wavesurferRef.current.getCurrentTime();
    const newTime = currentTime - 5;

    wavesurferRef.current.seekTo(newTime / wavesurferRef.current.getDuration());
  };

  return (
    <div className={Styles.container}>
      <div id="waveform" style={{ width: "100%", height: "80px" }}></div>
      <div className={Styles.audioControlsContainer}>
        <div className={Styles.audioControls}>
          <img
            className={Styles.forwardImage}
            alt=""
            src={forwardImage}
            onClick={goToFiveSeconds}
          />
          <img
            className={playerState ? Styles.pause : ""}
            src={playerState ? pauseImage : playImage}
            alt=""
            onClick={handlePlay}
          />
          <img
            className={Styles.backwardImage}
            src={forwardImage}
            onClick={backFiveSeconds}
            alt=""
          />
        </div>
        <div className={Styles.duration}>
          <h3>{convertNumbersToPersian(currentTime)}</h3>
          <h3>{convertNumbersToPersian(remainingTime)}</h3>
        </div>
      </div>
    </div>
  );
};

export default MP3Player;
